import React, { Fragment, useContext, ChangeEvent, useState } from "react";
import clsx from "clsx";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  Button,
  Select,
  MenuItem,
  ButtonGroup,
  Popover,
  TextField,
} from "@material-ui/core";
import {
  FormatShapesRounded,
  FormatPaintRounded,
  FormatBoldRounded,
  FormatItalicRounded,
  Autorenew,
} from "@material-ui/icons";
import { BlockPicker } from "react-color";
import Moveable from "react-moveable";
import { DesignContext } from "../../context/design";
import { textSizeList } from "../../constant/commons";

const useStyles = makeStyles((theme: Theme) => ({
  default: { color: theme.palette.secondary.main },
  active: { color: theme.palette.primary.main },
  spaceInGroup: {
    marginLeft: theme.spacing(0.5),
    marginTop: theme.spacing(1),
  },
  textInput: {
    marginTop: 0,
    marginBottom: 0,
    "& input": { paddingTop: 6.5, paddingBottom: 6.5 },
  },
  textInputLabel: { "& input": { paddingTop: 6.5, paddingBottom: 6.5 } },
  flexMiddle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  select: { height: theme.spacing(4) },
  btnSelect: {
    boxShadow: "unset",
    padding: theme.spacing(0.3),
    width: theme.spacing(4),
    height: theme.spacing(4),
    fontFamily: ["Montserrat-Bold", "Kanit-Bold"].join(","),
    minWidth: "unset",
  },
  target: {
    textAlign: "center",
    fontSize: 53,
    color: "#333",
    fontWeight: "bold",
    border: "1px solid #333",
    boxSizing: "border-box",
    width: theme.spacing(8),
    height: theme.spacing(8),
  },
  fiIcon: { height: theme.spacing(2.5), width: theme.spacing(2.5) },
}));

const TextLabel = () => {
  const classes = useStyles();
  const [colorpickEl, setcolorpickEl] = useState<HTMLButtonElement | null>(
    null
  );
  const [rotateEl, setrotateEl] = useState<HTMLButtonElement | null>(null);
  const [target, setTarget] = React.useState<any>(undefined);
  const [frame, setFrame] = React.useState({
    rotate: 0,
  });
  const { event, setevent, map } = useContext(DesignContext);
  const { type, feature } = event;

  const activeDrawLabel = () => {
    if (event.type === "anno-label") {
      setevent({ ...event, type: undefined, feature: undefined });
    } else {
      setevent({ ...event, type: "anno-label", feature: undefined });
    }
  };

  const _changeText = (e: ChangeEvent<HTMLInputElement>) => {
    let mapEvent: any = map;
    const draw = mapEvent._controls.find((control: any) => control.modes);
    setevent({
      ...event,
      feature: {
        ...feature,
        properties: {
          ...feature?.properties,
          [e.currentTarget.name]:
            e.currentTarget.type === "number"
              ? Number(e.currentTarget.value)
              : e.currentTarget.value,
        },
      },
    });
    draw.setFeatureProperty(
      feature?.id,
      e.currentTarget.name,
      e.currentTarget.type === "number"
        ? Number(e.currentTarget.value)
        : e.currentTarget.value
    );
  };

  const _changeSelect = (name: string) => (
    e: ChangeEvent<{ value: unknown }>
  ) => {
    let mapEvent: any = map;
    const draw = mapEvent._controls.find((control: any) => control.modes);
    setevent({
      ...event,
      feature: {
        ...feature,
        properties: {
          ...feature?.properties,
          [name]: e.target.value,
        },
      },
    });
    draw.setFeatureProperty(feature?.id, name, e.target.value);
  };

  const _changeColor = (e: any) => {
    let mapEvent: any = map;
    const draw = mapEvent._controls.find((control: any) => control.modes);
    setevent({
      ...event,
      feature: {
        ...feature,
        properties: {
          ...feature?.properties,
          "text-color": e.hex,
        },
      },
    });
    draw.setFeatureProperty(feature?.id, "text-color", e.hex);
  };

  const _changeRotate = (e: any) => {
    let mapEvent: any = map;
    const draw = mapEvent._controls.find((control: any) => control.modes);
    console.log(e);
    if (e.lastEvent) {
      setFrame({ rotate: e.lastEvent.rotate });
      setevent({
        ...event,
        feature: {
          ...feature,
          properties: {
            ...feature?.properties,
            "text-rotate": e.lastEvent.rotate,
          },
        },
      });
      draw.setFeatureProperty(feature?.id, "text-rotate", e.lastEvent.rotate);
    }
  };

  React.useEffect(() => {
    if (rotateEl) {
      if (feature?.properties && feature?.properties["text-rotate"]) {
        setFrame({
          rotate: feature?.properties["text-rotate"],
        });
      }
      setTimeout(() => {
        setTarget(document.getElementById("rotate-anno-text"));
        //
      }, 100);
    }
  }, [rotateEl]);

  return (
    <Fragment>
      <Popover
        open={Boolean(rotateEl)}
        anchorEl={rotateEl}
        onClose={() => {
          setrotateEl(null);
          setTarget(undefined);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div
          style={{
            position: "relative",
            width: 64,
            height: 64,
            padding: 50,
          }}
        >
          <div className="container">
            <div
              id="rotate-anno-text"
              className={classes.target}
              style={{ transform: `rotate(${frame.rotate}deg)` }}
            >
              A
            </div>
            {target && (
              <Moveable
                target={target}
                rotatable={true}
                throttleRotate={0}
                rotationPosition={"top"}
                zoom={1}
                origin={false}
                padding={{ left: 0, top: 0, right: 0, bottom: 0 }}
                onRotateStart={({ set }) => {
                  const value: number = feature?.properties
                    ? Number(feature?.properties["text-rotate"])
                    : 0;
                  set(value);
                }}
                onRotateEnd={_changeRotate}
                onRotate={({ beforeRotate }) => {
                  setFrame({ rotate: beforeRotate });
                }}
              />
            )}
          </div>
        </div>
      </Popover>
      <Popover
        open={Boolean(colorpickEl)}
        anchorEl={colorpickEl}
        onClose={() => {
          setcolorpickEl(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <BlockPicker
          color={
            feature?.properties?.["text-color"]
              ? feature?.properties?.["text-color"]
              : "#000000"
          }
          onChange={_changeColor}
        />
      </Popover>
      <Typography variant="subtitle2" className={clsx(classes.flexMiddle)}>
        Text:
      </Typography>
      <Button
        variant="outlined"
        size="small"
        color={
          Boolean(type === "anno-label" && !feature) ? "primary" : "inherit"
        }
        className={clsx(classes.btnSelect, classes.spaceInGroup)}
        onClick={activeDrawLabel}
        disabled={Boolean(type === "anno-label" && feature)}
      >
        <FormatShapesRounded
          className={clsx(
            Boolean(type === "anno-label" && !feature) && classes.active,
            !Boolean(type === "anno-label" && feature) && classes.default
          )}
        />
      </Button>
      <TextField
        className={clsx(classes.spaceInGroup, classes.textInput)}
        style={{ paddingTop: 8 }}
        variant="outlined"
        margin="dense"
        placeholder="Text label"
        disabled={!Boolean(type === "anno-label" && feature)}
        name="text"
        value={feature?.properties?.text ? feature.properties.text : ""}
        onChange={_changeText}
      />
      <Select
        className={clsx(classes.spaceInGroup, classes.select)}
        variant="outlined"
        margin="dense"
        disabled={!Boolean(type === "anno-label" && feature)}
        value={
          feature?.properties?.["text-font"]
            ? feature.properties["text-font"]
            : "Kanit"
        }
        onChange={_changeSelect("text-font")}
      >
        <MenuItem value={"Montserrat"}>Montserrat</MenuItem>
        <MenuItem value={"Kanit"}>Kanit</MenuItem>
      </Select>
      <Button
        variant="outlined"
        size="small"
        disabled={!Boolean(type === "anno-label" && feature)}
        className={clsx(classes.spaceInGroup, classes.btnSelect)}
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          setcolorpickEl(event.currentTarget);
        }}
      >
        <FormatPaintRounded
          className={clsx(
            Boolean(type === "anno-label" && feature) && classes.default
          )}
          style={{
            color: feature?.properties?.["text-color"]
              ? feature?.properties?.["text-color"]
              : "unset",
          }}
        />
      </Button>
      <ButtonGroup
        aria-label="outlined primary button group"
        className={classes.spaceInGroup}
        disabled={!Boolean(type === "anno-label" && feature)}
      >
        <Button className={classes.btnSelect}>
          <FormatBoldRounded
            className={clsx(
              Boolean(type === "anno-label" && feature) && classes.default
            )}
          />
        </Button>
        <Button className={classes.btnSelect}>
          <FormatItalicRounded
            className={clsx(
              Boolean(type === "anno-label" && feature) && classes.default
            )}
          />
        </Button>
      </ButtonGroup>
      <Select
        className={clsx(classes.spaceInGroup, classes.select)}
        variant="outlined"
        margin="dense"
        disabled={!Boolean(type === "anno-label" && feature)}
        value={
          feature?.properties?.["text-size"]
            ? feature.properties["text-size"]
            : 12
        }
        style={{ width: 80 }}
        onChange={_changeSelect("text-size")}
      >
        {textSizeList.map((ts: number) => (
          <MenuItem key={ts} value={ts}>
            {ts}
          </MenuItem>
        ))}
      </Select>
      <Button
        variant="outlined"
        size="small"
        className={clsx(classes.btnSelect, classes.spaceInGroup)}
        disabled={!Boolean(type === "anno-label" && feature)}
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          setrotateEl(event.currentTarget);
          setFrame({ rotate: Number(feature?.properties?.rotate) });
        }}
      >
        <Autorenew className={clsx(classes.fiIcon)} />
      </Button>
      {/* <TextField
        className={clsx(classes.spaceInGroup, classes.textInputLabel)}
        variant="outlined"
        margin="dense"
        label="rotate"
        type="number"
        name="text-rotate"
        style={{ width: 80 }}
        inputProps={{ min: 0, max: 359 }}
        disabled={!Boolean(type === "anno-label" && feature)}
        value={
          feature?.properties?.["text-rotate"]
            ? feature.properties["text-rotate"]
            : 0
        }
        onChange={_changeText}
      /> */}
    </Fragment>
  );
};

export default TextLabel;
